import styled from "styled-components";
import { cores } from "../../services/cores";
import { BackgroundImage } from "../../services/imagens";

export const Background = styled.div`
  background-image: url(${BackgroundImage});
  background-color: ${cores.roxoEscuro};
  height: ${(props) => `${props.altura}px`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 40px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 40px;

  @media screen and (max-width: 822px) {
    height: auto;
    padding-bottom: 80px;
  }
`;

export const BackgroundFooter = styled(Background)`
  display: ${({ display }) => (display ? "block" : "none")};
`;
